import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {catchError, map} from 'rxjs/operators';
import {throwError} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {TranslateService} from '@ngx-translate/core';
import {ToastHandlerService} from './toast-handler.service';
import {NEWSLETTER_ZONE} from '../models/newsletter';
import {USER_ROLE} from '../models/user';

@Injectable({
  providedIn: 'root'
})
export class NewslettersService {

  constructor(private http: HttpClient,
              private translateService: TranslateService,
              private toastService: ToastHandlerService) { }

  public getAlerts(zone: NEWSLETTER_ZONE): Promise<any> {
    return this.http.get(`${environment.backendUrl}user/alerts`, {
      params: {
        zone
      }
    })
      .pipe(
        map((res: any) => res.data),
        catchError(err => {
          this.toastService.showErrorToasts(
            this.translateService.instant('admin.alerts.get_alerts_error')
          );
          return throwError(err);
        })
      ).toPromise();
  }
}
